import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { MdsConfig } from '@maersk-global/mds-config';

//MdsConfig.iconsDynamicImportPath = process.env.NODE_ENV === 'development' ? '/node_modules/' : '/assets/node_modules/';

// mds icons are dynamically imported from the assets folder

MdsConfig.iconsDynamicImportPath = window.location.href.includes("digitalam") ? '/reliability/badactor/assets/' : '/assets/';


//Real User Monitoring Integration for akamai URL's
// Removed: RUM initialization moved to app.component.ts to defer until after user authentication

// Skip bootstrapping if we're in redirect mode (legacy Maersk.io hosts)
if (!(window as any).__BADACTOR_LEGACY_REDIRECT__) {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
